import { ICleanStoreAction } from 'store/reducers/types';

export interface ICategoriesReducer {
  isLoading: boolean,
  isUpdated: boolean,
  results: [],
}

export enum CategoriesActionsEnum {
  GetCategories = 'GET_CATEGORIES',
}

export interface IGegCategoriesAction {
  type: CategoriesActionsEnum.GetCategories,
  payload: { isLoading: boolean, isUpdated: boolean, results: any },
}

export type CategoriesActions = IGegCategoriesAction | ICleanStoreAction
